import { classNames } from '@zambezi/sdk/common'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import Toggle from './Toggle'

/**
 * Create a React Switch Toggle component
 *
 * @param {import('./interfaces').SwitchToggleProps} props
 * @returns {JSX.Element}
 */
function SwitchToggle ({ renderLabel, className, ...props }) {
  const renderFn = useCallback(
    ({ isPressed }) => (
      <span>
        <span className='zb-toggle-switch-label'>{renderLabel(isPressed)}</span>
        <span className='zb-toggle-switch-button'>
          <span className='zb-toggle-switch-button-inner' />
        </span>
        <span className='zb-toggle-switch-label-invert' aria-hidden='true'>
          {renderLabel(!isPressed)}
        </span>
      </span>
    ),
    [renderLabel]
  )

  return (
    <Toggle
      className={classNames('zb-toggle-switch', className)}
      renderFn={renderFn}
      {...props}
    />
  )
}

SwitchToggle.propTypes = {
  pressed: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultPressed: PropTypes.bool,
  tabIndex: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  renderLabel: PropTypes.func
}

SwitchToggle.defaultProps = {
  defaultPressed: false,
  pressed: undefined,
  disabled: false,
  tabIndex: '0',
  onChange: () => undefined,
  renderLabel: (isPressed) => (isPressed ? 'On' : 'Off')
}

export default SwitchToggle
